import React, { Fragment, useState, useEffect } from "react";
import tools from "../../components/tools/tools";
// import Select from '../../components/select'; // Temporarily comment out custom Select
import Loader from '../common/loader';
import { useNavigate } from 'react-router-dom'; // Import navigation hook
import '../../assets/scss/components/checkbox.scss'; 

const PREDEFINED_CARNET_TYPES = [
    { value: '1', label: 'Asistente', clave: '1' },
    { value: '3', label: 'Expositor', clave: '3' },       
    { value: '4', label: 'Invitado Especial', clave: '4' },
    { value: '6', label: 'Staff', clave: '6' },
    { value: '11', label: 'Ponente', clave: '11' },   
    // { value: '19', label: 'Socio', clave: '19' } 
];

const Default = ({
    esMesaRegistro,
}) => {
    const navigate = useNavigate(); 
    const [carnetTypes, setCarnetTypes] = useState([]); 
    const [selectedCarnetType, setSelectedCarnetType] = useState('');
    const [activeCarnets, setActiveCarnets] = useState([]); 

    const [paymentStatuses, setPaymentStatuses] = useState({
        0: false, // Cancelado
        1: false, // Pendiente de pago
        2: true,  // Pagado - selected
        3: false, // Por revisar
        4: true,  // No Aplica - selected
        5: true,  // Cortesía - selected
    });
    
     const [formatoAsistencia, setFormatoAsistencia] = useState({
        1: true,  // Presencial - 
        2: false,  // Virtual - 
    });
    
    const [statisticsData, setStatisticsData] = useState({ 
        totalAttendees: '-',
        printedCount: '-',
        remainingToPrint: '-',
        kitsDelivered: '-',
        remainingKits: '-',
    });
    const [loadingStatistics, setLoadingStatistics] = useState(false); 
    const [displayedCarnetTypeLabel, setDisplayedCarnetTypeLabel] = useState('Todos los tipos'); 

    useEffect(() => {
        async function fetchActiveCarnetsAndSetTypes() {
            console.log("Attempting to fetch carnet types for select...");
            try {
                const response = await fetch('/rt_carnets_activos', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });
                const data = await response.json();
                console.log("Raw data from /rt_carnets_activos for select:", data);

                if (data.status === 1 && data.carnets) {
                    setActiveCarnets(data.carnets || []); 
                    const activeApiValues = new Set(data.carnets.map(c => c.VALOR_TPO.toString()));

                    const filteredAndMappedCarnets = PREDEFINED_CARNET_TYPES.filter(predefinedType => 
                        activeApiValues.has(predefinedType.value)
                    );
                    
                    console.log("Filtered and mapped carnets for select:", filteredAndMappedCarnets);
                    
                    const finalCarnetTypesForSelect = [
                        { clave: '', label: 'Todos los tipos', value: '' },
                        ...filteredAndMappedCarnets 
                    ];
                    setCarnetTypes(finalCarnetTypesForSelect);
                    console.log("Set carnetTypes state for select to:", finalCarnetTypesForSelect);
                } else {
                    console.error('Error fetching carnet types for select from API:', data.message || 'No carnets found or status not 1. Data:', data);
                    setCarnetTypes([{ clave: '', label: 'Error al cargar tipos', value: '' }]);
                }
            } catch (error) {
                console.error('Exception while fetching carnet types for select:', error);
                setCarnetTypes([{ clave: '', label: 'Error al cargar tipos (exception)', value: '' }]);
            }
        }

        fetchActiveCarnetsAndSetTypes();
    }, []);

    useEffect(() => {
        console.log("carnetTypes state updated:", carnetTypes);
    }, [carnetTypes]);


    const fetchStatistics = async () => {
        const carnetObject = carnetTypes.find(c => c.value === selectedCarnetType);
        let labelToDisplay = 'Todos los tipos';
        if (carnetObject) {
            labelToDisplay = carnetObject.label; 
        } else if (selectedCarnetType) {
            const predefinedFallback = PREDEFINED_CARNET_TYPES.find(p => p.value === selectedCarnetType);
            labelToDisplay = predefinedFallback ? predefinedFallback.label : 'Desconocido';
        }
        
        setDisplayedCarnetTypeLabel(labelToDisplay);

        setLoadingStatistics(true);
        
        try {
             const formatosSeleccionados = Object.keys(formatoAsistencia)
                .filter(key => formatoAsistencia[key])
                .map(key => parseInt(key, 10));

            const response = await fetch('/rt_obtener_estadisticas', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    selectedCarnetType: selectedCarnetType, 
                    paymentStatuses: paymentStatuses,
                    formatoAsistencia: formatosSeleccionados  
                })
            });
            const result = await response.json();

            if (result.status === 1 && result.data) {
                setStatisticsData(result.data);
            } else {
                console.error('Error fetching statistics for main page from API:', result.message || 'No data returned');
                setStatisticsData({
                    totalAttendees: 0,
                    printedCount: 0,
                    remainingToPrint: 0,
                    kitsDelivered: 0,
                    remainingKits: 0,
                });
                tools.notie.alert({ type: 'error', text: result.message || 'Error al cargar estadísticas.', time: 3 });
            }
        } catch (error) {
            console.error('Exception while fetching statistics for main page:', error);
            setStatisticsData({
                totalAttendees: 0,
                printedCount: 0,
                remainingToPrint: 0,
                kitsDelivered: 0,
                remainingKits: 0,
            });
            tools.notie.alert({ type: 'error', text: 'Excepción al cargar estadísticas.', time: 3 });
        } finally {
            setLoadingStatistics(false);
        }
    };

    const handleStartPlayback = (displayMode) => {
        const actualCarnetTypesForCycle = carnetTypes.filter(ct => ct.value !== '');
        if (selectedCarnetType === '' && actualCarnetTypesForCycle.length === 0) {
            tools.notie.alert({ type: 'info', text: 'No hay tipos de carnet específicos para ciclar en "Todos los tipos".', time: 4 });
            return;
        }
        if (selectedCarnetType !== '' && !carnetTypes.some(ct => ct.value === selectedCarnetType)) {
             tools.notie.alert({ type: 'warning', text: 'El tipo de carnet seleccionado no es válido o no está cargado.', time: 4 });
            return;
        }

        navigate('/mesaregistro/estadistica/reproduccion', { 
            state: { 
                selectedCarnetType: selectedCarnetType, 
                paymentStatuses: paymentStatuses,
                formatoAsistencia: Object.keys(formatoAsistencia)
                    .filter(key => formatoAsistencia[key])
                    .map(key => parseInt(key, 10)),  
                displayMode: displayMode 
            } 
        });
    };
    
    const handleFormatoAsistenciaChange = (event) => {
        const { value, checked } = event.target;
        setFormatoAsistencia(prev => ({
            ...prev,
            [value]: checked,
        }));
    };

    const handleSearchClick = () => {
        fetchStatistics(); 
    };

    const handleReturn = () => {
        navigate('/mesaregistro');
    };

    const handleCarnetTypeChange = (value) => {
        setSelectedCarnetType(value);
    };

    const handlePaymentStatusChange = (event) => {
        const { name, checked } = event.target;
        setPaymentStatuses(prevStatuses => {
            const newStatuses = {
                ...prevStatuses,
                [name]: checked,
            };

            console.log("Payment Statuses updated:", newStatuses);
            return newStatuses;
        });
    };

    const paymentStatusOptions = [
        { value: '0', label: 'Cancelado' },
        { value: '1', label: 'Pendiente de Pago' },
        { value: '2', label: 'Pagado' },
        { value: '3', label: 'Por Revisar' },
        { value: '4', label: 'No Aplica' },
        { value: '5', label: 'Cortesía' },
    ];

    return (
        <div className="container d-flex justify-content-center" style={{ maxWidth: '80%', backgroundColor: '#f2f2f5', color: '#000' }}>
            <style>
                {`
                .custom-checkbox {
                    appearance: none !important;
                    -webkit-appearance: none !important;
                    -moz-appearance: none !important;
                    width: 20px !important;
                    height: 20px !important;
                    min-width: 20px !important;
                    min-height: 20px !important;
                    max-width: 20px !important;
                    max-height: 20px !important;
                    border-radius: 3px !important;
                    cursor: pointer !important;
                    position: relative !important;
                    outline: none !important;
                    display: inline-block !important;
                    vertical-align: middle !important;
                    flex-shrink: 0 !important;
                }
                .custom-checkbox:checked {
                    background-color: #28a745 !important;
                    border: 2px solid #28a745 !important;
                }
                .custom-checkbox:not(:checked) {
                    background-color: #dc3545 !important;
                    border: 2px solid #dc3545 !important;
                }
                .custom-checkbox:checked::after {
                    content: "✓";
                    position: absolute;
                    color: white;
                    font-size: 14px;
                    font-weight: bold;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    line-height: 1;
                }
                `}
            </style>
            <Fragment>
                <button 
                    onClick={handleReturn} 
                    className="btn btn-secondary" 
                    style={{ position: 'absolute', top: '10px', left: '10px' }}
                >
                    Regresar
                </button>
                
                <div className="col-sm-10 mt-5 registros-nuevos">
                    <div className="card mt-5" style={{ backgroundColor: '#fff', color: '#000' }}>
                        <div className="card-header p-0 mt-3">
                            <div className='row p-0 m-0 d-flex justify-content-center'>
                                <div className="col-sm-10 p-0 m-0 d-flex justify-content-center">
                                    <h5>Estadística</h5> 
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <label htmlFor="carnetTypeSelect">Tipo de Carnet:</label>
                                    <select
                                        id="carnetTypeSelect"
                                        value={selectedCarnetType}
                                        onChange={(e) => handleCarnetTypeChange(e.target.value)}
                                        className="form-control"
                                    >
                                        {carnetTypes.map(option => (
                                            <option key={option.clave || option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-8">
                                    <label>Estatus de Pago:</label>
                                    <div className="d-flex flex-wrap">
                                        {paymentStatusOptions.map(status => (
                                            <div key={status.value} className="form-check form-check-inline me-3 mb-2">
                                                <input
                                                    className="form-check-input custom-checkbox"
                                                    type="checkbox"
                                                    id={`status-${status.value}`}
                                                    name={status.value}
                                                    checked={paymentStatuses[status.value]}
                                                    onChange={handlePaymentStatusChange}
                                                />
                                                <label 
                                                    className="form-check-label ms-2" 
                                                    htmlFor={`status-${status.value}`}
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontWeight: paymentStatuses[status.value] ? '600' : '400',
                                                        color: paymentStatuses[status.value] ? '#007bff' : '#333',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    {status.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label>Formato de Asistencia:</label>
                                    <div className="d-flex flex-wrap">
                                        <div className="form-check form-check-inline me-4 mb-2">
                                            <input
                                                className="form-check-input custom-checkbox"
                                                type="checkbox"
                                                id="formato-presencial"
                                                value="1"
                                                checked={formatoAsistencia[1]}
                                                onChange={handleFormatoAsistenciaChange}
                                            />
                                            <label 
                                                className="form-check-label ms-2" 
                                                htmlFor="formato-presencial"
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: formatoAsistencia[1] ? '600' : '400',
                                                    color: formatoAsistencia[1] ? '#28a745' : '#333',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                Presencial
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline me-4 mb-2">
                                            <input
                                                className="form-check-input custom-checkbox"
                                                type="checkbox"
                                                id="formato-virtual"
                                                value="2"
                                                checked={formatoAsistencia[2]}
                                                onChange={handleFormatoAsistenciaChange}
                                            />
                                            <label 
                                                className="form-check-label ms-2" 
                                                htmlFor="formato-virtual"
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: formatoAsistencia[2] ? '600' : '400',
                                                    color: formatoAsistencia[2] ? '#dc3545' : '#333',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                Virtual
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-12 text-center">
                                    <button 
                                        onClick={handleSearchClick} 
                                        className="btn btn-primary me-2"
                                        disabled={loadingStatistics} 
                                    >
                                        {loadingStatistics ? 'Buscando...' : 'Buscar'}
                                    </button>
                                    <button
                                        onClick={() => handleStartPlayback('full')} 
                                        className="btn btn-success me-1" 
                                    >
                                        Reproducir Estadística
                                    </button>
                                    {/* <button
                                        onClick={() => handleStartPlayback('attendees_impressions')} 
                                        className="btn btn-info me-1" 
                                    >
                                        Asistentes/Impresiones
                                    </button>
                                    <button
                                        onClick={() => handleStartPlayback('attendees_kits')} 
                                        className="btn btn-warning" 
                                    >
                                        Asistentes/Kits
                                    </button> */}
                                </div>
                            </div>
                            <hr />
                            
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <h4>Resultados para: {displayedCarnetTypeLabel}</h4>
                                        <table className="table table-bordered table-striped">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Descripción</th>
                                                    <th>Cantidad</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Número de Asistentes</td>
                                                    <td>{statisticsData.totalAttendees}</td>
                                                </tr>
                                                <tr>
                                                    <td>Carnets Impresos</td>
                                                    <td>{statisticsData.printedCount}</td>
                                                </tr>
                                                <tr>
                                                    <td>Carnets Faltantes de Imprimir</td>
                                                    <td>{statisticsData.remainingToPrint}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td>Kits Entregados</td>
                                                    <td>{statisticsData.kitsDelivered}</td>
                                                </tr>
                                                <tr>
                                                    <td>Kits Faltantes de Entregar</td>
                                                    <td>{statisticsData.remainingKits}</td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </div>
            </Fragment>
        </div>
    );
};

export default Default;

